/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UnintegratedPaymentFields
 */
export interface UnintegratedPaymentFields {
    /**
     * 
     * @type {string}
     * @memberof UnintegratedPaymentFields
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UnintegratedPaymentFields
     */
    type: string;
    /**
     * 
     * @type {boolean}
     * @memberof UnintegratedPaymentFields
     */
    required: boolean;
    /**
     * 
     * @type {string}
     * @memberof UnintegratedPaymentFields
     */
    displayLabel: string;
}

/**
 * Check if a given object implements the UnintegratedPaymentFields interface.
 */
export function instanceOfUnintegratedPaymentFields(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "required" in value;
    isInstance = isInstance && "displayLabel" in value;

    return isInstance;
}

export function UnintegratedPaymentFieldsFromJSON(json: any): UnintegratedPaymentFields {
    return UnintegratedPaymentFieldsFromJSONTyped(json, false);
}

export function UnintegratedPaymentFieldsFromJSONTyped(json: any, ignoreDiscriminator: boolean): UnintegratedPaymentFields {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'type': json['type'],
        'required': json['required'],
        'displayLabel': json['displayLabel'],
    };
}

export function UnintegratedPaymentFieldsToJSON(value?: UnintegratedPaymentFields | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'type': value.type,
        'required': value.required,
        'displayLabel': value.displayLabel,
    };
}

